import styled from "styled-components";
import Layout from "../../components/layout/Layout";
import { SeoMeta } from "@/utils/seo/SeoMeta";

const PolicyWrapper = styled.div`
  & h4 {
    margin-bottom: 10px;
  }
  & pre {
    width: 100%;
    word-break: keep-all;
    white-space: pre-wrap;
    margin: 0px;
    line-height: 2;
  }
`;

const PrivacyPolicyPage = ({ isModal }) => {
  return (
    <>
      {isModal ? (
        <PolicyWrapper className="container">
          <pre>
            {`
칼렛스토어는 정보주체의 자유와 권리 보호를 위해 「개인정보 보호법」 및 관계 법령이 정한 바를 준수하여, 적법하게 개인정보를 처리하고 안전하게 관리하고 있습니다. 이에 「개인정보 보호법」 제30조에 따라 정보주체에게 개인정보 처리에 관한 절차 및 기준을 안내하고, 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다.

█ 개인정보의 처리목적
칼렛스토어는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 「개인정보 보호법」 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.
1. 회원 가입 및 관리 회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지, 각종 고지·통지, 고충처리 목적으로 개인정보를 처리합니다. 
2. 재화 또는 서비스 제공 물품배송, 서비스 제공, 계약서·청구서 발송, 콘텐츠 제공, 맞춤서비스 제공, 요금결제·정산, 채권추심으로 개인정보를 처리합니다. 

█ 개인정보의 처리 및 보유기간 
① 칼렛스토어는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의 받은 개인정보 보유·이용기간 내에서 개인정보를 처리· 보유합니다. 
② 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.
1. 홈페이지 회원 가입 및 관리 : 사업자/단체 홈페이지 탈퇴 시까지 
다만, 다음의 사유에 해당하는 경우에는 해당 사유 종료 시까지 
1) 관계 법령 위반에 따른 수사·조사 등이 진행 중인 경우에는 해당 수사·조사 종료 시까지 
2) 홈페이지 이용에 따른 채권·채무관계 잔존 시에는 해당 채권·채무관계 정산 시까지 
3) 예외사유 시에는 해당 사안의 해결 종료 시까지
2. 재화 또는 서비스 제공 : 재화·서비스 공급완료 및 요금결제·정산 완료시까지 
다만, 다음의 사유에 해당하는 경우에는 해당 기간 종료 시까지 
1) 「전자상거래 등에서의 소비자 보호에 관한 법률」에 따른 표시·광고, 계약내용 및 이행 등 거래에 관한 기록 
- 표시·광고에 관한 기록 : 6개월 
- 계약 또는 청약철회, 대금결제, 재화 등의 공급기록 : 5년 
- 소비자 불만 또는 분쟁처리에 관한 기록 : 3년 
2) 「통신비밀보호법」에 따른 통신사실확인자료 보관 
- 컴퓨터통신, 인터넷 로그기록자료, 접속지 추적자료 : 3개월 

█ 처리하는 개인정보 항목 
칼렛스토어는 다음의 개인정보 항목을 처리하고 있습니다. 
1. 회원 가입 및 관리, 서비스 제공
• 이름 및 업체명, 연락처, 이메일, 아이디, 비밀번호
1. 재화 제공
• 이름 및 업체명, 연락처, 주소

█ 개인정보의 제3자 제공
① 칼렛스토어는 정보주체의 개인정보를 개인정보의 처리 목적에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 개 「개인정보 보호법」 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공하고 그 이외에는 정보주체의 개인정보를 제3자에게 제공하지 않습니다. 
② 칼렛스토어는 원활한 서비스 제공을 위해 다음의 경우 정보주체의 동의를 얻어 필요 최소한의 범위로만 제공합니다. 
③ 칼렛스토어는 다음과 같이 재난, 감영병, 급박한 생명·신체 위험을 초래하는 사건·사고, 급박한 재산 손실 등의 긴급상황이 발생하는 경우 정보주체의 동의 없이 관계기관에 개인정보를 제공할 수 있습니다.
이 경우 칼렛스토어는 근거법령에 의거하여 필요한 최소한의 개인정보만을 제공하며, 목적과 다르게 제공하지 않겠습니다.

█ 개인정보의 파기 절차 및 방법
① 칼렛스토어는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다. 
② 정보주체로부터 동의받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관장소를 달리하여 보존합니다. 
③ 개인정보 파기의 절차 및 방법은 다음과 같습니다. 
1. 파기절차 
칼렛스토어는 파기 사유가 발생한 개인정보를 선정하고, 칼렛스토어의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다. 
2. 파기방법
칼렛스토어는 전자적 파일 형태로 기록·저장된 개인정보는 기록을 재생할 수 없도록 파기하며, 종이 문서에 기록·저장된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다. 

█ 정보주체와 법정대리인의 권리·의무 및 행사방법
① 정보주체는 칼렛스토어에 대해 언제든지 개인정보 열람·정정·삭제·처리정지 요구 등의 권리를 행사할 수 있습니다. 
② 권리 행사는 칼렛스토어에 대해 「개인정보 보호법」 시행령 제41조 제1항에 따라 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며, 칼렛스토어는 이에 대해 지체없이 조치하겠습니다. 
③ 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수도 있습니다. 이 경우 “개인정보 처리 방법에 관한 고시(제2020-7호)” 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다. 
④ 개인정보 열람 및 처리정지 요구는 「개인정보 보호법」 제35조 제4항, 제37조 제2항에 의하여 정보주체의 권리가 제한될 수 있습니다. 
⑤ 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다. 
⑥ 칼렛스토어는 정보주체 권리에 따른 열람의 요구, 정정·삭제의 요구, 처리 정지의 요구 시 열람 등 요구를 한 자가 본인이거나 정당한 대리인인지를 확인합니다.

█ 개인정보의 안전성 확보조치
칼렛스토어는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다. 
1. 관리적 조치 : 내부관리계획 수립·시행, 전담조직 운영, 정기적 직원 교육 
2. 기술적 조치 : 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 개인정보의 암호화, 보안프로그램 설치 및 갱신 
3. 물리적 조치 : 전산실, 자료보관실 등의 접근통제 
칼렛스토어는 개인정보의 안전성을 확보하기 위하여 법령에서 규정하고 있는 사항 이외에도 다음과 같은 활동을 시행하고 있습니다. 
1. 개인정보보호 활동: 소셜미디어 운영, 투명성 보고서 발간 
2. 국내외 개인정보보호 인증 획득: ISO/IEC 27701, ISMS-P

█ 개인정보 자동 수집 장치의 설치·운영 및 거부에 관한 사항 – 해당 시 의무항목임
① 칼렛스토어는 이용자에게 개별적인 맞춤서비스를 제공하기 위해 이용 정보를 저장하고 수시로 불러오는 ‘쿠키(cookie)’를 사용합니다. 
② 쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터내의 하드디스크에 저장되기도 합니다. 
가. 쿠키의 사용목적: 이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부, 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다. 
나. 쿠키의 설치·운영 및 거부 : 웹브라우저 상단의 도구>인터넷 옵션>개인정보 메뉴의 옵션 설정을 통해 쿠키 저장을 거부 할 수 있습니다. 
다. 쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다. 

█ 행태정보의 수집·이용 및 거부 등에 관한 사항
① 칼렛스토어는 서비스 이용과정에서 정보주체에게 최적화된 맞춤형 서비스 및 혜택, 온라인 맞춤형 광고 등을 제공하기 위하여 행태정보를 수집·이용하고 있습니다. 
② 칼렛스토어는 다음과 같이 행태정보를 수집합니다.
③ 칼렛스토어는 최소한의 행태정보만을 수집합니다.
‣ 웹브라우저를 통한 맞춤형 서비스 차단/허용 
(1) 인터넷 익스플로러(Windows 10용 Internet Explorer 11) 
- Internet Explorer에서 도구 버튼을 선택한 다음 인터넷 옵션을 선택 - 개인 정보 탭을 선택하고 설정에서 고급을 선택한 다음 쿠키의 차단 또는 허용을 선택 
(2) Microsoft Edge
- Edge에서 오른쪽 상단 ‘⋮’ 표시를 클릭한 후, 설정을 클릭합니다. 
- 설정 페이지 좌측의 ‘개인정보, 검색 및 서비스’를 클릭 후 「추적방지」 섹션에서 ‘추적방지’ 여부 및 수준을 선택합니다. 
- ‘InPrivate를 검색할 때 항상 “엄격” 추적 방지 사용’ 여부를 선택합니다. 
- 아래 「개인정보」 섹션에서 ‘추적 안함 요청보내기’ 여부를 선택합니다. 
(3) 크롬 브라우저 - Chrome에서 오른쪽 상단 ‘⋮’ 표시(chrome 맞춤설정 및 제어)를 클릭한 후, 설정 표시를 클릭합니다. 
- 설정 페이지 하단에 ‘고급 설정 표시’를 클릭하고 「개인정보」 섹션에서 콘텐츠 설정을 클릭합니다. 
- 쿠키 섹션에서 ‘타사 쿠키 및 사이트 데이터 차단’의 체크박스를 선택합니다. 
④ 정보주체는 아래의 연락처로 행태정보와 관련하여 궁금한 사항과 거부권 행사, 피해 신고 접수 등을 문의할 수 있습니다. 
‣ 개인정보 보호 담당부서 
부서명 : 플랫폼플러스팀 
담당자 : 하태환 
연락처 : 02-6964-6930

█ 추가적인 이용·제공 판단기준
① 은(는) 「개인정보 보호법」 제15조제3항 및 제17조제4항에 따라 「개인정보 보호법」 시행령 제14조의2에 따른 사항을 고려하여 정보주체의 동의 없이 개인정보를 추가적으로 이용·제공할 수 있습니다.
② 이에 따라 은(는) 정보주체의 동의 없이 추가적인 이용·제공을 하기 위해서 다음과 같은 사항을 고려하였습니다. 
‣ 개인정보를 추가적으로 이용·제공하려는 목적이 당초 수집 목적과 관련성이 있는지 여부 
‣ 개인정보를 수집한 정황 또는 처리 관행에 비추어 볼 때 추가적인 이용·제공에 대한 예측 가능성이 있는지 여부 
‣ 개인정보의 추가적인 이용·제공이 정보주체의 이익을 부당하게 침해하는지 여부 
‣ 가명처리 또는 암호화 등 안전성 확보에 필요한 조치를 하였는지 여부

█ 가명정보의 처리
은(는) 통계작성, 과학적 연구, 공익적 기록보존 등을 위하여 수집한 개인정보를 특정 개인을 알아볼 수 없도록 가명 리하여 다음과 같이 처리하고 있습니다.

‣ 법 제28조의4(가명정보에 대한 안전조치 의무 등)에 따른 가명정보의 안전성 확보조치에 관한 사항 
- 관리적 조치 : 내부관리계획 수립·시행, 정기적 직원 교육 등 
- 기술적 조치 : 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 고유식별정보 등의 암호화, 보안프로그램 설치 
- 물리적 조치 : 전산실, 자료보관실 등의 접근통제 

█ 개인정보 보호책임자
① 칼렛스토어는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다. 
‣ 개인정보 보호책임자 
성명 : 하태환 
직책 : 이사 
연락처 : 02-6964-6930
※ 개인정보보호 담당부서로 연결됩니다. 
‣ 개인정보 보호 담당부서 
부서명 : 플랫폼플러스팀
담당자 : 하태환 
연락처 : 02-6964-6930 
② 정보주체는 의 서비스(또는 사업)을 이용하시면서 발생한 모든 개인정보보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의할 수 있습니다. 칼렛스토어는 정보주체의 문의에 대해 지체없이 답변 및 처리해드릴 것입니다.

█ 국내대리인의 지정
정보주체는 「개인정보 보호법」 제39조의11에 따라 지정된 국내 대리인에게 개인정보 관련 고충처리 등의 업무를 위하여 연락을 취할 수 있습니다. 칼렛스토어는 정보주체의 개인정보 관련 고충처리 등 개인정보 보호책임자의 업무 등을 신속하게 처리할 수 있도록 노력하겠습니다. 
‣ 칼렛스토어는 「개인정보 보호법」 제39조의11에 따라 다음의 국내대리인을 지정하였습니다. 
국내 대리인의 상호 : 미래포장연구소 
국내대리인의 전화번호 : 070-4300-3546  
국내대리인의 전자우편 주소 : wooju@urbas.kr

█ 개인정보 열람청구
정보주체는 「개인정보 보호법」 제35조에 따른 개인정보의 열람 청구를 아래의 부서에 할 수 있습니다. 칼렛스토어는 정보주체의 개인정보 열람청구가 신속하게 처리되도록 노력하겠습니다. 
‣ 개인정보 열람청구 접수·처리 부서 
부서명 : 플랫폼플러스팀
담당자 : 하태환 
연락처 : 02-6964-6930

█ 권익침해 구제방법
① 정보주체는 개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다. 이 밖에 기타 개인정보침해의 신고, 상담에 대하여는 아래의 기관에 문의하시기 바랍니다.
1. 개인정보분쟁조정위원회 : (국번없이) 1833-6972 (www.kopico.go.kr) 
2. 개인정보침해신고센터 : (국번없이) 118 (privacy.kisa.or.kr) 
3. 대검찰청 : (국번없이) 1301 (www.spo.go.kr) 
4. 경찰청 : (국번없이) 182 (ecrm.cyber.go.kr) 
② 칼렛스토어는 정보주체의 개인정보자기결정권을 보장하고, 개인정보 침해로 인한 상담 및 피해 구제를 위해 노력하고 있으며, 신고나 상담이 필요한 경우 아래의 담당부서로 연락해 주시기 바랍니다. 
‣ 개인정보보호 관련 고객 상담 및 신고 
부서명 : 플랫폼플러스팀
담당자 : 하태환 
연락처 : 02-6964-6930
③ 「개인정보 보호법」 제35조(개인정보의 열람), 제36조(개인정보의 정정·삭제), 제37조(개인정보의 처리정지 등)의 규정에 의한 요구에 대 하여 공공기관의 장이 행한 처분 또는 부작위로 인하여 권리 또는 이익의 침해를 받은 자는 행정심판법이 정하는 바에 따라 행정심판을 청구할 수 있습니다. 
▸ 중앙행정심판위원회 : (국번없이) 110 (www.simpan.go.kr)

█ 개인정보 처리방침의 변경
① 이 개인정보 처리방침은 2021. 1. 1 부터 적용됩니다. 
`}
          </pre>
        </PolicyWrapper>
      ) : (
        <Layout
          parent={"홈"}
          sub={"개인정보 처리방침"}
          pageTitle={SeoMeta.privacyPolicy.title}
          pageDesc={SeoMeta.privacyPolicy.description}
          pageKeyword={SeoMeta.privacyPolicy.keywords}
        >
          <PolicyWrapper className="container mt-50 mb-50">
            <h4>칼렛스토어 개인정보 처리방침</h4>
            <pre>
              {`
칼렛스토어는 정보주체의 자유와 권리 보호를 위해 「개인정보 보호법」 및 관계 법령이 정한 바를 준수하여, 적법하게 개인정보를 처리하고 안전하게 관리하고 있습니다. 이에 「개인정보 보호법」 제30조에 따라 정보주체에게 개인정보 처리에 관한 절차 및 기준을 안내하고, 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다.

█ 개인정보의 처리목적
칼렛스토어는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 「개인정보 보호법」 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.
1. 회원 가입 및 관리 회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지, 각종 고지·통지, 고충처리 목적으로 개인정보를 처리합니다. 
2. 재화 또는 서비스 제공 물품배송, 서비스 제공, 계약서·청구서 발송, 콘텐츠 제공, 맞춤서비스 제공, 요금결제·정산, 채권추심으로 개인정보를 처리합니다. 

█ 개인정보의 처리 및 보유기간 
① 칼렛스토어는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의 받은 개인정보 보유·이용기간 내에서 개인정보를 처리· 보유합니다. 
② 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.
1. 홈페이지 회원 가입 및 관리 : 사업자/단체 홈페이지 탈퇴 시까지 
다만, 다음의 사유에 해당하는 경우에는 해당 사유 종료 시까지 
1) 관계 법령 위반에 따른 수사·조사 등이 진행 중인 경우에는 해당 수사·조사 종료 시까지 
2) 홈페이지 이용에 따른 채권·채무관계 잔존 시에는 해당 채권·채무관계 정산 시까지 
3) 예외사유 시에는 해당 사안의 해결 종료 시까지
2. 재화 또는 서비스 제공 : 재화·서비스 공급완료 및 요금결제·정산 완료시까지 
다만, 다음의 사유에 해당하는 경우에는 해당 기간 종료 시까지 
1) 「전자상거래 등에서의 소비자 보호에 관한 법률」에 따른 표시·광고, 계약내용 및 이행 등 거래에 관한 기록 
- 표시·광고에 관한 기록 : 6개월 
- 계약 또는 청약철회, 대금결제, 재화 등의 공급기록 : 5년 
- 소비자 불만 또는 분쟁처리에 관한 기록 : 3년 
2) 「통신비밀보호법」에 따른 통신사실확인자료 보관 
- 컴퓨터통신, 인터넷 로그기록자료, 접속지 추적자료 : 3개월 

█ 처리하는 개인정보 항목 
칼렛스토어는 다음의 개인정보 항목을 처리하고 있습니다. 
1. 회원 가입 및 관리, 서비스 제공
• 이름 및 업체명, 연락처, 이메일, 아이디, 비밀번호
1. 재화 제공
• 이름 및 업체명, 연락처, 주소
 
█ 개인정보의 제3자 제공
① 칼렛스토어는 정보주체의 개인정보를 개인정보의 처리 목적에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 개 「개인정보 보호법」 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공하고 그 이외에는 정보주체의 개인정보를 제3자에게 제공하지 않습니다. 
② 칼렛스토어는 원활한 서비스 제공을 위해 다음의 경우 정보주체의 동의를 얻어 필요 최소한의 범위로만 제공합니다. 
③ 칼렛스토어는 다음과 같이 재난, 감영병, 급박한 생명·신체 위험을 초래하는 사건·사고, 급박한 재산 손실 등의 긴급상황이 발생하는 경우 정보주체의 동의 없이 관계기관에 개인정보를 제공할 수 있습니다.
이 경우 칼렛스토어는 근거법령에 의거하여 필요한 최소한의 개인정보만을 제공하며, 목적과 다르게 제공하지 않겠습니다.

█ 개인정보의 파기 절차 및 방법
① 칼렛스토어는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다. 
② 정보주체로부터 동의받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관장소를 달리하여 보존합니다. 
③ 개인정보 파기의 절차 및 방법은 다음과 같습니다. 
1. 파기절차 
칼렛스토어는 파기 사유가 발생한 개인정보를 선정하고, 칼렛스토어의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다. 
2. 파기방법
칼렛스토어는 전자적 파일 형태로 기록·저장된 개인정보는 기록을 재생할 수 없도록 파기하며, 종이 문서에 기록·저장된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다. 

█ 정보주체와 법정대리인의 권리·의무 및 행사방법
① 정보주체는 칼렛스토어에 대해 언제든지 개인정보 열람·정정·삭제·처리정지 요구 등의 권리를 행사할 수 있습니다. 
② 권리 행사는 칼렛스토어에 대해 「개인정보 보호법」 시행령 제41조 제1항에 따라 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며, 칼렛스토어는 이에 대해 지체없이 조치하겠습니다. 
③ 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수도 있습니다. 이 경우 “개인정보 처리 방법에 관한 고시(제2020-7호)” 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다. 
④ 개인정보 열람 및 처리정지 요구는 「개인정보 보호법」 제35조 제4항, 제37조 제2항에 의하여 정보주체의 권리가 제한될 수 있습니다. 
⑤ 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다. 
⑥ 칼렛스토어는 정보주체 권리에 따른 열람의 요구, 정정·삭제의 요구, 처리 정지의 요구 시 열람 등 요구를 한 자가 본인이거나 정당한 대리인인지를 확인합니다.

█ 개인정보의 안전성 확보조치
칼렛스토어는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다. 
1. 관리적 조치 : 내부관리계획 수립·시행, 전담조직 운영, 정기적 직원 교육 
2. 기술적 조치 : 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 개인정보의 암호화, 보안프로그램 설치 및 갱신 
3. 물리적 조치 : 전산실, 자료보관실 등의 접근통제 
칼렛스토어는 개인정보의 안전성을 확보하기 위하여 법령에서 규정하고 있는 사항 이외에도 다음과 같은 활동을 시행하고 있습니다. 
1. 개인정보보호 활동: 소셜미디어 운영, 투명성 보고서 발간 
2. 국내외 개인정보보호 인증 획득: ISO/IEC 27701, ISMS-P

█ 개인정보 자동 수집 장치의 설치·운영 및 거부에 관한 사항 – 해당 시 의무항목임
① 칼렛스토어는 이용자에게 개별적인 맞춤서비스를 제공하기 위해 이용 정보를 저장하고 수시로 불러오는 ‘쿠키(cookie)’를 사용합니다. 
② 쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터내의 하드디스크에 저장되기도 합니다. 
가. 쿠키의 사용목적: 이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부, 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다. 
나. 쿠키의 설치·운영 및 거부 : 웹브라우저 상단의 도구>인터넷 옵션>개인정보 메뉴의 옵션 설정을 통해 쿠키 저장을 거부 할 수 있습니다. 
다. 쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다. 

█ 행태정보의 수집·이용 및 거부 등에 관한 사항
① 칼렛스토어는 서비스 이용과정에서 정보주체에게 최적화된 맞춤형 서비스 및 혜택, 온라인 맞춤형 광고 등을 제공하기 위하여 행태정보를 수집·이용하고 있습니다. 
② 칼렛스토어는 다음과 같이 행태정보를 수집합니다.
③ 칼렛스토어는 최소한의 행태정보만을 수집합니다.
‣ 웹브라우저를 통한 맞춤형 서비스 차단/허용 
(1) 인터넷 익스플로러(Windows 10용 Internet Explorer 11) 
- Internet Explorer에서 도구 버튼을 선택한 다음 인터넷 옵션을 선택 - 개인 정보 탭을 선택하고 설정에서 고급을 선택한 다음 쿠키의 차단 또는 허용을 선택 
(2) Microsoft Edge
- Edge에서 오른쪽 상단 ‘⋮’ 표시를 클릭한 후, 설정을 클릭합니다. 
- 설정 페이지 좌측의 ‘개인정보, 검색 및 서비스’를 클릭 후 「추적방지」 섹션에서 ‘추적방지’ 여부 및 수준을 선택합니다. 
- ‘InPrivate를 검색할 때 항상 “엄격” 추적 방지 사용’ 여부를 선택합니다. 
- 아래 「개인정보」 섹션에서 ‘추적 안함 요청보내기’ 여부를 선택합니다. 
(3) 크롬 브라우저 - Chrome에서 오른쪽 상단 ‘⋮’ 표시(chrome 맞춤설정 및 제어)를 클릭한 후, 설정 표시를 클릭합니다. 
- 설정 페이지 하단에 ‘고급 설정 표시’를 클릭하고 「개인정보」 섹션에서 콘텐츠 설정을 클릭합니다. 
- 쿠키 섹션에서 ‘타사 쿠키 및 사이트 데이터 차단’의 체크박스를 선택합니다. 
④ 정보주체는 아래의 연락처로 행태정보와 관련하여 궁금한 사항과 거부권 행사, 피해 신고 접수 등을 문의할 수 있습니다. 
‣ 개인정보 보호 담당부서 
부서명 : 플랫폼플러스팀 
담당자 : 하태환 
연락처 : 02-6964-6930

█ 추가적인 이용·제공 판단기준
① 은(는) 「개인정보 보호법」 제15조제3항 및 제17조제4항에 따라 「개인정보 보호법」 시행령 제14조의2에 따른 사항을 고려하여 정보주체의 동의 없이 개인정보를 추가적으로 이용·제공할 수 있습니다.
② 이에 따라 은(는) 정보주체의 동의 없이 추가적인 이용·제공을 하기 위해서 다음과 같은 사항을 고려하였습니다. 
‣ 개인정보를 추가적으로 이용·제공하려는 목적이 당초 수집 목적과 관련성이 있는지 여부 
‣ 개인정보를 수집한 정황 또는 처리 관행에 비추어 볼 때 추가적인 이용·제공에 대한 예측 가능성이 있는지 여부 
‣ 개인정보의 추가적인 이용·제공이 정보주체의 이익을 부당하게 침해하는지 여부 
‣ 가명처리 또는 암호화 등 안전성 확보에 필요한 조치를 하였는지 여부

█ 가명정보의 처리
은(는) 통계작성, 과학적 연구, 공익적 기록보존 등을 위하여 수집한 개인정보를 특정 개인을 알아볼 수 없도록 가명 리하여 다음과 같이 처리하고 있습니다.

‣ 법 제28조의4(가명정보에 대한 안전조치 의무 등)에 따른 가명정보의 안전성 확보조치에 관한 사항 
- 관리적 조치 : 내부관리계획 수립·시행, 정기적 직원 교육 등 
- 기술적 조치 : 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 고유식별정보 등의 암호화, 보안프로그램 설치 
- 물리적 조치 : 전산실, 자료보관실 등의 접근통제 

█ 개인정보 보호책임자
① 칼렛스토어는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다. 
‣ 개인정보 보호책임자 
성명 : 하태환 
직책 : 이사 
연락처 : 02-6964-6930
※ 개인정보보호 담당부서로 연결됩니다. 
‣ 개인정보 보호 담당부서 
부서명 : 플랫폼플러스팀
담당자 : 하태환 
연락처 : 02-6964-6930 
② 정보주체는 의 서비스(또는 사업)을 이용하시면서 발생한 모든 개인정보보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의할 수 있습니다. 칼렛스토어는 정보주체의 문의에 대해 지체없이 답변 및 처리해드릴 것입니다.

█ 국내대리인의 지정
정보주체는 「개인정보 보호법」 제39조의11에 따라 지정된 국내 대리인에게 개인정보 관련 고충처리 등의 업무를 위하여 연락을 취할 수 있습니다. 칼렛스토어는 정보주체의 개인정보 관련 고충처리 등 개인정보 보호책임자의 업무 등을 신속하게 처리할 수 있도록 노력하겠습니다. 
‣ 칼렛스토어는 「개인정보 보호법」 제39조의11에 따라 다음의 국내대리인을 지정하였습니다. 
국내 대리인의 상호 : 미래포장연구소 
국내대리인의 전화번호 : 070-4300-3546  
국내대리인의 전자우편 주소 : wooju@urbas.kr

█ 개인정보 열람청구
정보주체는 「개인정보 보호법」 제35조에 따른 개인정보의 열람 청구를 아래의 부서에 할 수 있습니다. 칼렛스토어는 정보주체의 개인정보 열람청구가 신속하게 처리되도록 노력하겠습니다. 
‣ 개인정보 열람청구 접수·처리 부서 
부서명 : 플랫폼플러스팀
담당자 : 하태환 
연락처 : 02-6964-6930

█ 권익침해 구제방법
 ① 정보주체는 개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다. 이 밖에 기타 개인정보침해의 신고, 상담에 대하여는 아래의 기관에 문의하시기 바랍니다.
1. 개인정보분쟁조정위원회 : (국번없이) 1833-6972 (www.kopico.go.kr) 
2. 개인정보침해신고센터 : (국번없이) 118 (privacy.kisa.or.kr) 
3. 대검찰청 : (국번없이) 1301 (www.spo.go.kr) 
4. 경찰청 : (국번없이) 182 (ecrm.cyber.go.kr) 
② 칼렛스토어는 정보주체의 개인정보자기결정권을 보장하고, 개인정보 침해로 인한 상담 및 피해 구제를 위해 노력하고 있으며, 신고나 상담이 필요한 경우 아래의 담당부서로 연락해 주시기 바랍니다. 
‣ 개인정보보호 관련 고객 상담 및 신고 
부서명 : 플랫폼플러스팀
담당자 : 하태환 
연락처 : 02-6964-6930
③ 「개인정보 보호법」 제35조(개인정보의 열람), 제36조(개인정보의 정정·삭제), 제37조(개인정보의 처리정지 등)의 규정에 의한 요구에 대 하여 공공기관의 장이 행한 처분 또는 부작위로 인하여 권리 또는 이익의 침해를 받은 자는 행정심판법이 정하는 바에 따라 행정심판을 청구할 수 있습니다. 
▸ 중앙행정심판위원회 : (국번없이) 110 (www.simpan.go.kr)

█ 개인정보 처리방침의 변경
① 이 개인정보 처리방침은 2021. 1. 1 부터 적용됩니다. 
`}
            </pre>
          </PolicyWrapper>
        </Layout>
      )}
    </>
  );
};
export default PrivacyPolicyPage;
